exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* .spinner-layer {\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    opacity: 0;\n    border-color: #fcfdfd;\n} */", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/arsalan/Desktop/Dev Stack/Otacon (npm start)/src/app/_components/components_includes/spinner/spinner.component.css
// module id = ../../../../../src/app/_components/components_includes/spinner/spinner.component.css
// module chunks = main